import type { AiBusinessCenterModule } from '../types'

export const hrmModule: AiBusinessCenterModule = {
  key: 'hrm',
  label: '人力资源',
  desc: '员工档案 / 考勤管理 / 招聘管理 / 绩效管理 / 薪酬管理 / 社保公积金',
  path: '/hrm',
  homePath: '/hrm/home/hr',
  icon: 'ep:user',
  color: '#8b5cf6',
  aliases: ['HRM', '人力资源', '人事系统', 'HR', '人事']
}
